import { create } from 'zustand';

/**
 * Guide or tiles, remembered on THIS DEVICE.
 *
 * Live TV and the guide were two nav items, which was a category error of the
 * same kind as the filter rail: they are not two destinations, they are two
 * presentations of one thing, and a view mode sitting in the navigation is a
 * control beside the screen that belongs inside it. One item, one fewer focus
 * stop, and the guide by default — which is the cable-box behaviour the whole
 * thing was shaped around.
 *
 * PER DEVICE RATHER THAN PER ACCOUNT, deliberately. The right answer differs
 * by screen and not by person: the television wants the guide, a phone wants
 * tiles, and the same human uses both. Storing it against the account would
 * mean the choice made on a 55-inch greets you on a handset, where it is the
 * wrong shape.
 *
 * localStorage, wrapped — it can be absent or throw in a private window and a
 * cleared browser, and a missing preference is a default, never an error.
 */
export type LiveView = 'guide' | 'tiles';

const KEY = 'n8m.liveView';

function load(): LiveView {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'guide' || v === 'tiles') return v;
  } catch { /* private window, blocked storage */ }
  return 'guide';
}

interface State {
  view: LiveView;
  set(v: LiveView): void;
  toggle(): void;
}

export const useLiveView = create<State>((set, get) => ({
  view: load(),
  set: (view) => {
    try { localStorage.setItem(KEY, view); } catch { /* not worth a word */ }
    set({ view });
  },
  toggle: () => get().set(get().view === 'guide' ? 'tiles' : 'guide'),
}));
